import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/valuation.svg";
var ValuationOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ValuationOutline_default as default
};
